export const environment = {
  production: true,
  log: false,
  environmentName: 'prod',
  version: 5.5,
  api_url: '', // DEV url
  web_url: 'https://super.houseofagents.ai/',
  // api_url: 'https://uatapi.hour4u.com', // UAT url
  //api_url: 'https://api.hour4u.com', // PROD url


  orderService: 'https://un7g8dheph.execute-api.ap-south-1.amazonaws.com/wo-prod/payment-service',
  ratingService: 'https://vvk28pqr98.execute-api.ap-south-1.amazonaws.com/wo-prod/rating-service',
  authService: 'https://k7y5ehmued.execute-api.ap-south-1.amazonaws.com/wo-prod/auth-service',
  jobService: 'https://zycnh7h7zj.execute-api.ap-south-1.amazonaws.com/wo-prod/enterprise-job-service',
  notificationService: 'https://pw7q65i4l5.execute-api.ap-south-1.amazonaws.com/wo-prod/notification-service',
  jobSeekerService: 'https://xpphw2tkm2.execute-api.ap-south-1.amazonaws.com/wo-prod/job-seeker',
  enterpriseAdminService: 'https://zycnh7h7zj.execute-api.ap-south-1.amazonaws.com/wo-prod/enterprise-job-service/v1',

  callingService: 'https://tr1q6rmvce.execute-api.ap-south-1.amazonaws.com/dev/',
  image_url: 'https://image-data-hour4u-2.s3.ap-south-1.amazonaws.com/',
  projectAPI: 'https://lfp9espk89.execute-api.ap-south-1.amazonaws.com/v1/',
  projectAPIKey: 'zhmwAT71dQwVBkP3fwQF9n3y8dWbUKl1j7W2kCk5',
  pipecatAPI: 'https://mumbai-prd-websocket.houseofagents.ai',
  whatsappAPI: 'https://wa-api.houseofagents.ai',
  serriTemplatesApiUrl: 'https://api.serri.co.in/api',
  serriTemplatesApiKey: '',

  rezorpayKey: 'rzp_live_0lOqy628mUvmnm',
  twilioAccountSid: 'AC1022a35bc56fbf9e71220921127a0394',
  twilioAuthToken: 'ff51c9f98f3910f8c05b55bcb6ef6c8e',
  oauthClientId: 'web-client',
  oauthClientSecret: 'hour4u',
  contactSuppportNumber: "917397998705",

  googleClientId: "875702098024-j0kq8h0ms1nbt1p40v8b1cfg4lokh950.apps.googleusercontent.com",
  globalAgentId: "global",
  googleScope: 'profile email https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/gmail.send',
  websocketURL: 'wss://pvv3qxvn3c.execute-api.ap-south-1.amazonaws.com/dev/',
  /** Optional VocalLabs direct WS URL (prod). */
  vocallabsWsUrl: '',
  metaAppId: '1392832858859365', // Facebook/Meta App ID for WhatsApp Business (update for production if different)
  metaApiVersion: 'v21.0', // Meta API version
  interaktApiKey: 'NTg3ZUs2bUFTWjRhMjd2TEowNmlYTENhSHQ4Sm5DVkMxbTJRUzUxZmpxczo=', // Interakt API Key - set in environment-specific files
  assistantApiUrl: 'https://arya-prd.mumbai-sandbox-websocket.houseofagents.ai', // PROD Arya backend (ECS Fargate, prd cluster). Built with `ng build --prod` (environment.prod.ts); dev uses environment.dev.ts.
  arya: {
    /**
     * QR connect — keep ON in prod until Serri API is live.
     * Flip to false once typed-number (Serri) is the primary path.
     */
    whatsappQrConnect: true,
    /** Typed-number + Save field: ON. */
    whatsappNumberInput: true,
  },
};
